<div class="progress-snackbar" *ngIf="progress$ | async as progressData">
  <div class="snackbar-content">
    <div class="message">  {{ progressData.message }}</div>
    <div class="progress-info">
      <mat-progress-bar 
        mode="determinate" 
        [value]="progressData.progress"
        class="progress-bar">
      </mat-progress-bar>
      <span class="progress-text">{{ progressData.progress }}%</span>
    </div>
  </div>
</div>
